<template>
    <div>
        <CommonPopupFrame :changeBottom="0" :changeHeight="60" :isOpen="isOpen" :closeCompleteAction="closeCompleteAction">
            <div style="width: 36px; height: 5px; background-color: #d9d9d9; margin: 0 auto; border-radius: 5px; margin-top: 5px"></div>
            <div @click="closeCompleteAction" style="padding-left: 12px; margin-top: 6px; font-weight: 700; color: #808080; height: 30px; width: 50px;">닫기</div>
            <div @touchmove.stop="() => { }" style="margin-top: 31px; flex: 1; overflow-y: scroll; padding: 0 12px; padding-bottom: 20px;">
                <div style="text-align: center;">
                    <div style="font-weight: 700; font-size: 32px; line-height: 46px;">링크 추가하기</div>
                    <div style="margin-top: 15px; font-weight: 500; line-height: 24px; margin-bottom: 40px;">유튜브 링크를 첨부하세요.</div>
                    <div style="position:relative;" v-if="!isShowYoutubeFrame">
                        <input style="width: 100%; background-color: #f5f5f5; outline: none; border: none; border-radius: 12px; padding: 12px; padding-left: 40px;" placeholder="URL 입력" @keyup="detectLink" @blur="detectLink" @click.stop ref="linkRef" v-model="youtubeLink" />
                        <img :src="require('@/assets/img/soccerhow_write_link_url.png')" style="position:absolute; left:12px; top:50%; transform: translateY(-50%); width:20px; height:18px;">
                    </div>
                    <div v-else>
                        <div style="border-radius:12px;overflow:hidden; ">
                            <ContentsViewer :contents="youtubeLink" style="" />
                        </div>
                        <div style="display:flex; margin-top:10px;">
                            <div style="flex:1;"></div>
                            <div style="color:#FF7111; font-size:14px; font-weight:bold;" @click="deleteUrl">URL 삭제</div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="height: 90px; padding: 0 12px;">
                <div @click="save" v-if="youtubeLink !== ''" class="save_btn_active">등록하기</div>
                <div v-else class="save_btn_unactive">등록하기</div>
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'
import ContentsViewer from '@/components/common/ContentsViewer'
import ResponseCode from '../../ResponseCode'
// import { PROFILE_BOX_LIST } from '@/Constants'

export default {
    name: 'SettingMedia',
    components: { CommonPopupFrame, ContentsViewer },
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
        closeCompleteAction: {
            type: Function,
            default: () => { },
        },
    },
    data() {
        return {
            intro: '',
            isShowYoutubeFrame: false,
            youtubeLink: ''
        }
    },
    methods: {
        deleteUrl() {
            this.isShowYoutubeFrame = false;
            this.youtubeLink = '';
        },
        async save() {
            const formData = new FormData();

            if (this.youtubeLink === '') {
                this.$GlobalStore.showAlert('링크를 기입해주세요.')
                return
            }

            formData.append('youtube_link', this.youtubeLink);
            this.$GlobalStore.showProgress();
            const res = await this.$Axios.post('/api/coach/media/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
            this.$GlobalStore.hideProgress();
            if (res.data.code === ResponseCode.SUCCESS) {
                this.closeCompleteAction(true)
            } else if (res.data.code === ResponseCode.FAIL) {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        detectLink() {
            const isYoutubeLinkComplete = this.$Util.checkYoutubeLink(this.youtubeLink);
            if (isYoutubeLinkComplete) {
                this.isShowYoutubeFrame = true;
            }
        },
    },
    watch: {
        isOpen(newVal) {
            if (!newVal) {
                this.youtubeLink = ''
                this.isShowYoutubeFrame = false
            }
        }
    },
    created() {
        this.save = this.$Once(this.save)
    }
}
</script>

<style scoped>
.common_box {
    padding: 10px;
    border-radius: 12px;
    background-color: #f5f5f5;
    margin-top: 40px;
}

.save_btn_active {
    height: 48px;
    line-height: 48px;
    border-radius: 12px;
    background-color: #210f03;
    text-align: center;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    margin-top: 12px;
}

.save_btn_unactive {
    height: 48px;
    line-height: 48px;
    border-radius: 12px;
    background-color: #f5f5f5;
    text-align: center;
    color: #d9d9d9;
    font-size: 14px;
    font-weight: 500;
    margin-top: 12px;
}

.active {
    background-color: #210f03;
    color: #fff;
}

input::placeholder {
    font-weight: 500;
    font-size: 14px;
    color: #bbbbbb;
}
</style>